// @ts-strict-ignore
import { Mesh } from 'three';
import { MetaElementVO } from '@shared/vo/meta-element.vo';
import { MetaElementUtils } from './meta-element.utils';

export class ConnectionDefinition {
  public type: string;
  public subtype: string;
  public name: string;
  public isInternal: boolean = false;
  public orderNumber: number;

  public constructor(type: string = null, subtype: string = null) {
    this.type = type;
    this.subtype = subtype;
  }
}

export class ConnectionConfiguration {
  public metaElement: MetaElementVO;
  public connectionMesh: Mesh;

  public constructor(metaElement: MetaElementVO = null, connectionMesh: Mesh = null) {
    this.metaElement = metaElement;
    this.connectionMesh = connectionMesh;
  }

  public get connectionName(): string {
    return this.metaElement == null ? null : this.metaElement.name;
  }

  public updateConnectionName(name: string): void {
    if (this.metaElement) {
      this.metaElement.name = name;
    }
    if (this.connectionMesh) {
      this.connectionMesh.name = name;
    }
  }

  public applyInternalConnectionPostfix(): void {
    const nameWithPostfix: string = MetaElementUtils.applyInternalConnectionPostfix(this.connectionName);
    this.updateConnectionName(nameWithPostfix);
  }
}
